<!-- 站点维护 -->
<template>
  <div class="maintain">
    <div class="title">
      <img src="@/assets/images/systemicon/logo.svg" alt="" />
    </div>
    <div class="content">
      <div class="bulletin">
        {{ attrs.site_switch_bulletin }}
      </div>
      <div class="footer">
        <div>{{formattedTime}}</div>
        <div>SKINROLL GROUP</div>
      </div>
    </div>
    <!-- {{attrs}} -->
  </div>
</template>

<script setup>
import { ref, computed, useAttrs, onMounted, onBeforeUnmount } from "vue";
const $attrs = useAttrs();
const attrs = computed(() => {
  return {
    ...$attrs,
  };
});

const timer = ref(null);
const currentTime = ref(new Date());

const formattedTime = computed(() => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // 使用UTC时间方法
  const year = currentTime.value.getUTCFullYear();
  const month = months[currentTime.value.getUTCMonth()]; // UTC月份
  const day = currentTime.value.getUTCDate(); // UTC日期
  const hours = String(currentTime.value.getUTCHours()).padStart(2, "0");
  const minutes = String(currentTime.value.getUTCMinutes()).padStart(2, "0");
  const seconds = String(currentTime.value.getUTCSeconds()).padStart(2, "0"); // 添加秒数

  return `${month} ${day}, ${year} ${hours}:${minutes}:${seconds} UTC`; // 添加秒数和UTC标识
});

onMounted(() => {
  timer.value = setInterval(() => {
    currentTime.value = new Date(); // 更新时间时会自动触发computed更新
  }, 1000);
});

onBeforeUnmount(() => {
  clearInterval(timer.value);
});
</script>
<style lang="scss" scoped>
.maintain {
  background-image: url("@/assets/images/index/maintenance.jpg");
  background-repeat: no-repeat;
  background-position: top center;
  height: 100vh;
  font-size: 0.3rem;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-items: center;
  .title {
    display: flex;
    justify-content: center;
    margin-top: 1.06rem;
    margin-bottom: 1.02rem;
    img {
      width: 3.15rem;
      height: 1.05rem;
    }
  }
  .content {
    font-size: 0.22rem;
    color: #d8f4f6;
    text-indent: 0.4rem;
    padding-left: 1.63rem;
    padding-right: 6.72rem;
    .bulletin {
    }
    .footer {
      margin-top: 1rem;
      text-align: right;
    }
  }
}
</style>
